:host {
  display: grid;
  box-sizing: border-box;
  font-family: var(--cwc-sans-serif-regular, 'EricssonHilda-Regular');
  font-size: 20px;
  color: var(--cwc-color-white, #FAFAFA);
}

::slotted(*) {
  text-wrap: balance;
}

.tint {
  padding: 6.25rem 1.125rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-container.center {
  margin: 0 auto;
}

.content-container.right {
  margin: 0 0 0 auto;
}

@media (min-width: 768px) {
  .tint {
    padding: 6.25rem 2.4rem;
  }
}

@media (min-width: 1024px) {
  .tint {
    padding: 6.25rem 5rem;
  }
}
